import { Skeleton, Stack, Paper } from '@mui/material';
import { OverallScoreBar } from 'services/candidate/components/CandidateReportDrawer/OverallScoreBar';
import { RequirementOutcomesList } from 'services/candidate/components/CandidateReportDrawer/RequirementOutcomesList';
import { extractListItems } from 'core/utils/apollo/extractListItems';
import { ApplicationForm } from 'services/candidate/components/CandidateReportDrawer/ApplicationForm';
import { CandidateByCandidateProfile } from 'modules/candidate-profile-analysis/types/CandidateByCandidateProfile';
import { CvViewer } from 'components/CvViewer';
import { AnalysisErrorNotice } from 'services/candidate/components/AnalysisError';

const CandidateProfileAnalysisDetailsSkeleton: React.FC = () => {
  return (
    <Stack direction="column" gap="40px">
      <Skeleton variant="rectangular" height={46} />
      <Skeleton variant="rectangular" height={560} />
    </Stack>
  );
};

type CandidateProfileAnalysisDetailsProps = {
  candidate: CandidateByCandidateProfile | null;
};

export const CandidateProfileAnalysisDetails: React.FC<
  CandidateProfileAnalysisDetailsProps
> = ({ candidate }) => {
  if (!candidate) {
    return <CandidateProfileAnalysisDetailsSkeleton />;
  }

  const requirementOutcomes = extractListItems(
    candidate.requirementOutcomes?.items ?? []
  );

  return (
    <Stack direction="row" gap="50px">
      <Stack direction="column" flex={1}>
        {candidate.analysisErrorCode ? (
          <AnalysisErrorNotice code={candidate.analysisErrorCode} />
        ) : (
          <>
            <OverallScoreBar totalScoreScaled={candidate.totalScoreScaled} />
            <RequirementOutcomesList
              requirementOutcomes={requirementOutcomes}
            />
          </>
        )}
      </Stack>
      <Stack flex={1}>
        {candidate.cvS3Key && (
          <Stack mb={2}>
            <Paper
              elevation={1}
              sx={{
                p: 2,
                height: '600px',
                overflow: 'auto'
              }}
            >
              <CvViewer
                cvS3Key={candidate.cvS3Key}
                cvParsedText={candidate.cvParsedText}
              />
            </Paper>
          </Stack>
        )}
        {!!candidate.atsQuestionnaireAnswers?.length && (
          <ApplicationForm
            atsQuestionnaireAnswers={candidate.atsQuestionnaireAnswers ?? []}
            createdAt={candidate.createdAt}
          />
        )}
      </Stack>
    </Stack>
  );
};
